import { Component, Inject, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import { CerereTypeService } from "src/app/platform/nomenclatoare/cerere-type/cerere-type.service";
import { NotificationService } from "src/app/services/notification.service";
import { PermissionsService } from "src/app/services/permissions.service";
import { CereriService } from "../../cereri/cereri.service";
import { environment } from "src/environments/environment";
import { finalize } from "rxjs";
import { helper } from "src/environments/helper";

@Component({
    selector: "app-add-borderou",
    templateUrl: "./add-borderou.component.html",
    styleUrls: ["./add-borderou.component.scss"],
})
export class AddBorderouComponent implements OnInit {
    isLoading: boolean = false;
    form!: FormGroup;
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    date: string = '';
    name: string = '';

    constructor(
        private dialogRef: MatDialogRef<AddBorderouComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
        public toastr: ToastrService,

        public cerereTypeService: CerereTypeService
    ) {
        this.date = data.date;
        this.name = data.name;
    }

    files: any = {
        files_borderou: [],
    };

    uploading: any = {
        files_borderou: false,
    };

    uploadedFileNames: string[] = [];

    ngOnInit(): void {
        this.form = this.fb.group({
            files: this.fb.array([]),
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    removeFile(index: number) {
        const files = this.form.get("files") as FormArray;
        if (index > -1 && index < files.length) {
            files.removeAt(index);
        }
    }

    onFileSelected(event: any, section: any) {
        const files = event.target.files;
        let filesArray;
        if (files) {
            filesArray = this.form.get("files") as FormArray;
        }

        Array.from(files).forEach((file: any) => {
            if (!this.uploadedFileNames.includes(file.name)) {
                this.uploadedFileNames.push(file.name);
                const fileControl = new FormControl(file);

                filesArray.push(fileControl);
            }
        });
    }

    deleteFile(fileName: string, section: any) {
        const nameIndex = this.uploadedFileNames.indexOf(fileName);
        if (nameIndex > -1) {
            this.uploadedFileNames.splice(nameIndex, 1);
        }
        let filesArray: any;
        filesArray = this.form.get("files") as FormArray;

        // const filesArray = this.sendMessageForm.get('files') as FormArray;
        const fileIndex = filesArray.controls.findIndex(
            (control: any) => control.value.name === fileName
        );
        if (fileIndex > -1) {
            filesArray.removeAt(fileIndex);
        }
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    addFile(event: any, key: "file") {
        event.eventPreventDefault = true;
        const inputElement = event.target as HTMLInputElement;
        if (!inputElement.files) {
            return;
        }

        const files = inputElement.files;
        console.log(files);
        // Iterate through the selected files and append them to the 'files' array in the form
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            this.uploading[key] = true;
            console.log(this.uploading);

            const formData = new FormData();
            formData.append("file", file, file.name);
            console.log(formData);

            this.cereriService.fileUpload(formData).subscribe({
                next: (result: any) => {
                    let response =
                        typeof result.status_code !== "undefined" ? result : result.error;
                    if (typeof response.status_code !== "undefined") {
                        if (
                            response.status_code == 200 &&
                            typeof response.data !== "undefined"
                        ) {
                            // Handle the uploaded file by adding it to the 'files' array in the form
                            const files = this.form.get("files") as FormArray;
                            files.push(new FormControl(result.data));

                            this.uploading[key] = false;
                            this.openToast({
                                title: this.successTitle,
                                message:
                                    helper.dialogConfig.generalMessages.fileSuccessfullyUploaded,
                                type: this.successIcon,
                            });
                        }
                    } else {
                        let errorMessage =
                            environment.config.customNotifications.generalMessages.error;
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            errorMessage,
                            this.errorIcon
                        );
                        this.isLoading = false;
                        this.uploading[key] = false;
                    }
                },
                error: (result: any) => {
                    this.isLoading = false;
                    this.uploading[key] = false;
                    this.onHttpError(result.error);
                },
            });
        }
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    submitForm() {
        this.isLoading = true;

        const { files } = this.form?.value
        const data = { files, type_slug: this.data.type_slug, date: this.date };

        // console.log(data);

        this.cereriService
            .fileUploadBorderou(data)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
